module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "markup-popup-form-dashed"
  }, [(_vm.name) ? _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.name))]) : _vm._e(), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7ecb5bc","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/markup/popup/form/dashed/component.vue
// module id = 4a76ee85b12bd1e5ba5a
// module chunks = 89